var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"filter-widget"},_vm._l((_vm.filterList),function(item,index){return _c('span',{key:index,staticClass:"filter-btn",class:_vm.activeFilter==item.value ? 'active': '',on:{"click":function($event){return _vm.onFilter(item)}}},[_vm._v(_vm._s(item.text))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }